import { useEffect, useMemo, useState } from "react";
import { IntakeStoreContextWrapper } from "@customer/contexts";
import { IntakeStore } from "@customer/stores/IntakeStore";

export const useCreateIntakeStore = (options?: { shouldSetContext?: boolean }) => {
    const [shouldSetContext, setShouldSetContext] = useState<boolean>(Boolean(options?.shouldSetContext));

    useEffect(() => {
        if (options)
            setShouldSetContext(Boolean(options.shouldSetContext));
    }, [options])

    const [intakeStore] = useMemo(() => {
        const store = new IntakeStore();
        if (shouldSetContext)
            IntakeStoreContextWrapper.set(store);
        return [store];
    }, [shouldSetContext]);

    return intakeStore;
}
